import { useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

/**
 * Generates a unique ID for form fields and accessibility attributes.
 * Uses the name prop if provided (more semantic), otherwise generates a UUID.
 * Compatible with React 17 (useId was introduced in React 18).
 * 
 * @param name - Optional name prop to use as base for the ID
 * @returns A unique string ID
 */
export function useId(name?: string): string {
  const idRef = useRef<string | null>(null);
  
  if (idRef.current === null) {
    if (name) {
      // Use name-based ID for better semantics and predictability
      idRef.current = `${name}-${uuidv4().substring(0, 8)}`;
    } else {
      // Fallback to UUID for truly unique IDs
      idRef.current = `field-${uuidv4()}`;
    }
  }
  
  return idRef.current;
}

